export default __webpack_public_path__ + "static/media/across-logo-v2.cafd6e95.svg";